module.exports = __webpack_public_path__ + "img/horizontal_7_6_8004.e605f5fa.png";